import { render, staticRenderFns } from "./RoutingOSPFShow.vue?vue&type=template&id=d2cc978e&"
import script from "./RoutingOSPFShow.vue?vue&type=script&lang=js&"
export * from "./RoutingOSPFShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports